/**
 *  @class
 *  @function Gallery
 */
if (!customElements.get('theme-gallery')) {
  class ThemeGallery extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.galleryVideoList = Array.from(
        this.querySelectorAll('.gallery--item .gallery__video')
      );

      this.hoverPlayList = this.galleryVideoList.filter(item => {
        return item.classList.contains('hover-play') && item;
      });

      this.autoPlayList = this.galleryVideoList.filter(item => {
        return !item.classList.contains('hover-play') && item;
      });

      if (this.autoPlayList.length) {
        const observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              const video = entry.target.querySelector('video');
              if (!video) return;
              if (entry.isIntersecting) {
                video.play();
              } else {
                video.pause();
              }
            });
          },
          { rootMargin: '0px 0px 300px 0px' }
        );
        this.autoPlayList.forEach(item => observer.observe(item));
      }

      this.setHoverPlayList();
    }
    setHoverPlayList() {
      this.hoverPlayList.forEach((item, i) => {
        item.querySelector('video').currentTime = 0.1;
        item.parentElement.addEventListener('mouseenter', () =>
          this.playVideo(item)
        );
        item.parentElement.addEventListener('mouseleave', () =>
          this.pauseVideo(item)
        );
      });
    }

    playVideo(videoContainer) {
      videoContainer.querySelector('video').play();
    }
    pauseVideo(videoContainer) {
      videoContainer.querySelector('video').pause();
    }
  }
  customElements.define('theme-gallery', ThemeGallery);
}
